import { CloseOutlined, MobileOutlined, ReadOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";
import { BannerButton } from "@/shared/pwa/banner/views/banner-button";
import { usePwaBanner } from "@/shared/pwa/banner/model/use-pwa-banner";

export function PwaBanner() {
  const t = useTranslations("PwaBanner");
  const {
    visible,
    handleInstall,
    handleDismiss,
    ARTICLE_URL,
    isInstallationAvailable,
  } = usePwaBanner();

  if (!visible) return null;

  return (
    <div className="lg:hidden fixed bottom-0 z-20 w-full rounded-t-lg bg-gradient-to-t from-[#016908] from-[41%] to-[#14b514] shadow-md overflow-hidden">
      <button
        onClick={handleDismiss}
        className="absolute right-2 top-2 flex items-center justify-center size-8 rounded-full text-white/80 hover:text-white hover:bg-white/10 transition-colors cursor-pointer border-none bg-transparent"
        aria-label={t("Close")}
      >
        <CloseOutlined className="text-sm" />
      </button>

      <div className="flex flex-col gap-5 p-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center size-12 rounded-2xl bg-white/25 shrink-0">
            <MobileOutlined className={"text-[white] text-lg"} />
          </div>
          <div className="flex flex-col pr-8">
            <span className="text-base font-bold leading-5 text-white">
              {t("Install the app")}
            </span>
            <span className="text-sm font-normal leading-4 text-white/90">
              {t("Open on mobile device")}
            </span>
          </div>
        </div>

        <div>
          {isInstallationAvailable ? (
            <BannerButton onClick={handleInstall}>
              {t("Install app")}
            </BannerButton>
          ) : (
            <BannerButton
              href={ARTICLE_URL}
              target={"_blank"}
              icon={<ReadOutlined />}
            >
              {t("Instruction")}
            </BannerButton>
          )}
        </div>
      </div>
    </div>
  );
}
